import GetNovedades from '@/modules/novedad/application/GetNovedades'
import CreateNovedad from '@/modules/novedad/application/CreateNovedad'
import UpdateNovedad from '@/modules/novedad/application/UpdateNovedad'
import NovedadApiRepository from '@/modules/novedad/infrastructure/NovedadApiRepository'

const repository = new NovedadApiRepository()

export default {
  namespaced: true,

  state: {
    novedades: [],
    selectedNovedad: null,
  },

  getters: {
    getNovedades: (state) => state.novedades,
    getSelectedNovedad: (state) => state.selectedNovedad,
  },

  mutations: {
    SET_NOVEDADES(state, novedades) {
      state.novedades = novedades
    },
    SET_SELECTED_NOVEDAD(state, novedad) {
      state.selectedNovedad = novedad ? { ...novedad } : null
    },
    CLEAR_SELECTED_NOVEDAD(state) {
      state.selectedNovedad = null
    },
  },

  actions: {
    async fetchNovedades({ commit }) {
      try {
        const novedades = await new GetNovedades(repository).execute()
        commit('SET_NOVEDADES', novedades)
      } catch {
        commit('SET_SNACKBAR_MESSAGE', 'No fue posible obtener las novedades.', { root: true })
      }
    },

    async createNovedad({ dispatch, commit }, { idPersonal, novedad }) {
      try {
        await new CreateNovedad(repository).execute(idPersonal, novedad)
        commit('SET_SNACKBAR_MESSAGE', 'Novedad registrada correctamente.', { root: true })
        await dispatch('fetchNovedades')
      } catch {
        commit('SET_SNACKBAR_MESSAGE', 'No fue posible registrar la novedad.', { root: true })
        throw new Error('Error al crear novedad')
      }
    },

    async updateNovedad({ dispatch, commit }, { idPersonal, idNovedad, novedad }) {
      try {
        await new UpdateNovedad(repository).execute(idPersonal, idNovedad, novedad)
        commit('SET_SNACKBAR_MESSAGE', 'Novedad actualizada correctamente.', { root: true })
        await dispatch('fetchNovedades')
      } catch {
        commit('SET_SNACKBAR_MESSAGE', 'No fue posible actualizar la novedad.', { root: true })
        throw new Error('Error al actualizar novedad')
      }
    },

    setSelectedNovedad({ commit }, novedad) {
      commit('SET_SELECTED_NOVEDAD', novedad)
    },

    clearSelectedNovedad({ commit }) {
      commit('CLEAR_SELECTED_NOVEDAD')
    },
  },
}
